import styled from "styled-components"

export const Container = styled.div`
    display: flex;

     .fill{
       min-width: 4rem;
    }
`

export const Content = styled.div`
  width: 100%;
`